<template>
        <ValidationObserver class="row" ref="form" >
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl">
                            Create User
                        </div>
                        <div class="form mt-3">
                            <div class="row">

                                <ValidationProvider
                                    class="col-md-6"
                                    name="First Name"
                                    rules="required|latin|min:2|max:100"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">First Name</label>
                                        <input type="text" class="form-control" v-model="form.name">
                                        <FormError :error="errors[0]" name="First Name"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Last Name"
                                    rules="required|latin|min:2|max:100"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Last Name</label>
                                        <input type="text" class="form-control" v-model="form.last_name">
                                        <FormError :error="errors[0]" name="Last Name"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Phone number"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Phone Number</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-mask="'+1 (###) ###-####'"
                                            v-model="form.cell_number"
                                        >
                                        <FormError :error="errors[0]"  name="Phone number"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Email"
                                    rules="email|required"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Email Address</label>
                                        <input type="text" class="form-control" v-model="form.email">

                                        <FormError :error="errors[0]" name="Email"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Job title"
                                    rules="min:6|required"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Job Title</label>
                                        <input type="text" class="form-control" v-model="form.job_title">
                                        <FormError :error="errors[0]" name="Job title"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Password"
                                    rules="min:6|required"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Password</label>
                                        <input type="password" class="form-control" v-model="form.password">
                                        <FormError :error="errors[0]" name="Password"></FormError>
                                    </div>
                                </ValidationProvider>

                                <div
                                    class="col-md-6"

                                >
                                    <label for="" class="form-label">Status</label>
                                    <div class="buttons-type-multiselect two-btns ">
                                        <ValidationProvider
                                            name="status"
                                            rules="required"
                                            v-slot="{ errors }"
                                            class="item active-green"
                                        >
                                            <input
                                                v-model="form.status"
                                                type="radio"
                                                name="name22"
                                                class="rad"
                                                id="id-1132"
                                                value="active">
                                            <label for="id-1132">
                                                <div class="ttl">Active</div>
                                            </label>
                                            <FormError :error="errors[0]" name="status"></FormError>
                                        </ValidationProvider>
                                        <div class="item inactive">
                                            <input
                                                v-model="form.status"
                                                type="radio"
                                                name="name22"
                                                class="rad"
                                                id="id-1212"
                                                value="inactive"
                                            >
                                            <label for="id-1212">
                                                <span class="ttl">Inactive</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5" >
                                <div class="col-md-12">
                                    <div class="btns-wrap">
                                        <a
                                            href="/master-admin/settings/users"
                                           class="btn btn--outline-primary w-100 w-sm-auto">Cancel
                                        </a>
                                        <button
                                            class="btn btn--secondary w-100 w-sm-auto"
                                            @click="saveUser">Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
</template>

<script>
import UsersServices from "./services/UsersServices";
import MaskedInput from "vue-text-mask";

export default {
    name: 'NewUser',
    components: {
        MaskedInput
    },
    data() {
        return {
            form: {
                name: null,
                last_name: null,
                cell_number: null,
                email: null,
                job_title: null,
                password: null,
                status: null,

            }
        }
    },
    methods: {
        async saveUser() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            try {
                await UsersServices.saveNewUser(this.form)
                this.$showSuccessMessage('New user has been created')
                setTimeout(()=> {
                    window.location.href = `/master-admin/settings/users`
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The new user was not created')
            }
        }
    }

}

</script>



<style scoped>

</style>
